const e = "@gjensidige/builders-components", n = "1.15.5";
export {
  e as name,
  n as version
};
//# sourceMappingURL=package.json.js.map
